// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__385Pd","actions":"GroupTable_actions__3RFXL","deleteModalFooter":"GroupTable_deleteModalFooter__2CvHZ"};